import { AnyAction, Middleware } from 'redux';
import axios from 'axios';
import { RootState } from '@reducers';
import { Message } from '@rootCommon/services';
import { getErrorMessage } from '@rootCommon/utilities/common';

// eslint-disable-next-line @typescript-eslint/ban-types
export const catchErrors: Middleware<{}, RootState> = () => (next) => (action: AnyAction) => {
  const result = next(action);

  if (result.payload && (result.payload instanceof Error || axios.isAxiosError(result.payload))) {
    const statusCode = axios.isAxiosError(result.payload) && result.payload.response?.status;
    const isAuthorized = statusCode !== 401;
    const message = getErrorMessage(result.payload);

    isAuthorized && Message.error(message);
  }

  return result;
};

export default catchErrors;
